import { ApplicationState } from '../store';

export const getIsNotified = (state: ApplicationState) => state.app.isNotified;
export const getUserId = (state: ApplicationState) => state.app.user?.id;
export const getUserEmail = (state: ApplicationState) => state.app.user?.email;
export const getAppIsLoading = (state: ApplicationState) => state.app.isLoading;
export const getShowSignUpError = (state: ApplicationState) =>
  state.app.showSignUpError;
